import { Button, Field, Input } from "@client/components/ui";
import { ApiError, api } from "@client/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";

export const Route = createFileRoute("/login")({
  component: LoginPage,
});

function describeLoginError(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 401) return "Nieprawidłowe hasło.";
    if (error.status === 429) return "Zbyt wiele prób. Spróbuj ponownie za chwilę.";
    return error.message;
  }
  return "Nie udało się zalogować.";
}

function LoginPage() {
  const [password, setPassword] = useState("");
  const qc = useQueryClient();
  const navigate = useNavigate();

  const loginMutation = useMutation({
    mutationFn: (pw: string) => api.auth.login(pw),
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["auth"] });
      await navigate({ to: "/" });
    },
  });

  const errorMessage = loginMutation.isError ? describeLoginError(loginMutation.error) : null;

  return (
    <div className="flex min-h-screen items-center justify-center bg-app p-6">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (password.length > 0) loginMutation.mutate(password);
        }}
        className="flex w-full max-w-sm flex-col gap-4 rounded-md border border-line bg-surface p-6"
      >
        <div className="flex flex-col items-center gap-2 pb-2">
          <img src="/icon.svg" width={40} height={40} alt="Drabina" />
          <div className="text-lg font-bold text-fg-1">Drabina</div>
        </div>
        <Field label="Hasło">
          {(id) => (
            <Input
              id={id}
              type="password"
              autoFocus
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          )}
        </Field>
        {errorMessage != null && <div className="text-xs text-danger">{errorMessage}</div>}
        <Button type="submit" loading={loginMutation.isPending} disabled={password.length === 0}>
          Zaloguj
        </Button>
      </form>
    </div>
  );
}
